// Share only concurrent reads. Completed responses are never cached here.
export function createPendingRequests() {
   const pending = new Map();
   return {
      clear: () => pending.clear(),
      run(key, request) {
         if (pending.has(key)) return pending.get(key);
         const promise = Promise.resolve().then(request).finally(() => {
            // An older request must not evict a read started after invalidation.
            if (pending.get(key) === promise) pending.delete(key);
         });
         pending.set(key, promise);
         return promise;
      },
   };
}
